<template>
  <div>
    <main>
      <div id="HomeContainer">
          <div class="ContentAligher">

            <div class="row">
              <div class="col-md-5 col-md-offset-7">
                  <div id="HeroTitle">
                    <h1 class="bold"><span class="small">New York’s Finest</span>
                    <span class="mid">Elevator Interiors  </span>
                    <span>That Inspire & Impress</span></h1>

                    <p>Welcome to USC Elevators Interiors, where passion meets experience and know-how. gathered over 20 years, in a continual quest for excellence. </p>

                     <router-link class="link" to="/catalog" >View Our Designs</router-link>
                  </div>


              </div>
            </div>

            <div class="row">
              <div class="col-md-10 col-md-offset-1">
                <div class="row">
                  <div class="col-md-4">
                    <div class="HeroBoxItem bg_yellow parallax"  data-speed="3" data-margin="0" data-rotate="0" data-rotatestatus="false">
                      <h3 class="white">360 Cab Viewer</h3>
                      <hr/>
                      <img :src="require('@/assets/images/custom-design.jpg')" />
                      <p>We provide the ability to see the details of each render as if you just stepped inside the elevator.</p><br/>
                      <a target='_blank' href="https://momento360.com/e/uc/325085058d69444ca22d330de951f660?utm_campaign=embed&utm_source=other" >View in 360</a>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="HeroBoxItem bg_black parallax"  data-speed="3" data-margin="0" data-rotate="0" data-rotatestatus="false" >
                      <h3 class="white">CAB Builder</h3>
                      <hr/>
                      <img :src="require('@/assets/images/cab-builder.jpg')" />
                      <p>We design, engineer and finalize quality cabs. Make a selection of an option that’s just right for you.</p><br/>
                      <router-link to="/cab-builder" >Customize</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>



          <div class="RContentAligher">
              <div id="OurProcess">
                  <div class="row">
                    <div class="col-md-5">
                      <h1 class="bold white">Our Process</h1>
                      <span class="TagLine">Why hassle when we can Hustle</span>
                      <p>Our team of professionals is with our clients every step of the way. Beginning with architectural drawings, we ensure that project measurements and dimensions are precise. We walk our clients through every step, whether it be replacements or modernization, all the while working within the given budget. Our vast selection of finishes and design allows for the customization of each cab to match the clients’ vision. </p>
                    </div>
                    <div class="col-md-6 col-md-offset-1">
                        
                            <div id="processTab">          
                              <ul class="resp-tabs-list vert">
                                  <li> Design </li>
                                  <li> Structural Planing </li>
                                  <li> Manufacturing </li>
                                  <li> Installation </li>
                              </ul> 

                              <div class="resp-tabs-container vert">   
                                  <div class="verticalAlign"> 
                                      <h3>Design</h3>
                                      <p>Select one of many design options from our catalog. A sales representative will work with you every step of the way to customize it and bring your vision to reality.</p>
                                  </div>       
                                  <div class="verticalAlign"> 
                                      <h3>Structural Planing</h3>
                                      <p>A certified mechanic will take the measurement and provide our engineering team with a survey. They will make architectural drawings that will integrate the design selected with the measurements of your elevator.</p>
                                  </div>                                              
                                  <div class="verticalAlign"> 
                                      <h3>Manufacturing </h3>
                                      <p>Once the drawings are approved the manufacturing phase will begin.</p>
                                  </div>
                                  <div class="verticalAlign"> 
                                      <h3>Installation</h3>
                                      <p>Being that we pride ourselves in efficiency, the installation just takes 1-3 days. Once the project is completed, a field supervisor will make the final inspection.</p>
                                  </div>
                              </div>
                          </div>    
                    </div>
                  </div>
              </div>

              <div class="BGArrowRight parallax"  data-speed="-10" data-margin="-500" data-rotate="0" data-rotatestatus="false" ></div>
          </div>
      </div>
    </main>
    <rwv-our-clients></rwv-our-clients>
    <rwv-general-form></rwv-general-form>
  </div>
</template>
<script>

//import RwvSubscribe from '@/components/Subscribe'
import * as $ from 'jquery'
import Vue from 'vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);


import '@/assets/js/easyResponsiveTabs'

import RwvGeneralForm from '@/components/GeneralForm';
import RwvOurClients from '@/components/OurClients';

export default{
  name: 'Home',
  components: {
    RwvGeneralForm, 
    RwvOurClients
  },
  data: function() {
    return {
     // banner:require('./../../static/images/home.jpg'),
    }
  },
  mounted() {

      $("#xxx").click(function(){
        $('.resp-tab-item').eq( 1 ).trigger("click");
      });

      $('#processTab').easyResponsiveTabs({ tabidentify: 'vert', type: 'vertical' });
      //alert('cccccccccccc');
      $(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
  },
  updated(){
     //$('#processTab').easyResponsiveTabs({ tabidentify: 'vert', type: 'vertical' });
     //$(".parallax").inertiaScroll({  parent: $("#SiteWrapper")  });
     //alert('aaaaaaaaaaaa');
  },
  methods: {

  }
}

</script>
<style>
@import './../assets/css/easyResponsiveTabs.css';
</style>


// WEBPACK FOOTER //
// src/views/Home.vue